import { Col, Row } from 'react-bootstrap';
import React, { useCallback, useEffect, useState } from 'react';

import { DatePicker } from 'antd';
import ReactApexChart from 'react-apexcharts';
import moment from 'moment'; // Import Moment.js
import telemetryController from '../../redux/api/tbTelemetryController';
import { useTranslation } from 'react-i18next';

function Timeline({ deviceId, dataDiagram }) {
  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const [dataSource, setDataSoure] = useState([]);
  const [pumpLabel, setPumpLabel] = useState([]);

  // date present
  var today = moment(); // Sử dụng Moment.js để lấy thời gian hiện tại
  const date = today.format('YYYY-MM-DD');
  const [datepicker, setDatepicker] = useState(date);
  const keys = 'pump1,pump2,pump3,pump4,pump5,pump6,pump7,pump8';

  const fetchData = useCallback(async (startTs, endTs) => {
    const data = await telemetryController.getTimeseries(
      token,
      deviceId,
      keys,
      startTs,
      endTs
    );

    let rowData = [];
    let indexRow = 0;
    for (const pump in data) {
      const pumpData = data[pump].map((item, idx) => ({
        index: ++indexRow,
        key: idx,
        time: moment(item.ts).add(7, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        device: pump,
        state: item.value,
      }));
      Array.prototype.push.apply(rowData, pumpData);
    }
    setDataSoure(rowData);
  });

  useEffect(() => {
    const startTs = moment(datepicker + ' 00:00:00').valueOf();
    const endTs = moment(datepicker + ' 23:59:59').valueOf();
    fetchData(startTs, endTs);
  }, [datepicker, deviceId]);

  useEffect(() => {
    if (dataDiagram) {
      let newItems = {};
      dataDiagram
        ?.filter(
          (item) =>
            (item.type === 'pump' ||
              item.type === 'vf' ||
              item.type === 'van') &&
            item.number >= 1 &&
            item.number <= 5
        )
        .map(
          (item) =>
            (newItems[
              (item.type === 'vf' || item.type === 'van' ? 'pump' : item.type) +
                item.number
            ] = item.label)
        );
      setPumpLabel(newItems);
    }
  }, [dataDiagram]);

  const [display, setDisplay] = useState(false);

  useEffect(() => {
    setTimeout(() => setDisplay(true), 1);
  }, []);

  if (!display) {
    return <></>;
  }

  const dateFormat = 'YYYY-MM-DD';
  let hours = 0;
  let minutes = 0;
  let seconds2 = 0;
  let seconds1 = 0;
  let seconds = 0;
  let result = 0;
  let sum = '';

  let dataOn = [],
    dataOff = [];
  let currentDevice = null;

  for (let index = 0; index < dataSource.length - 1; index++) {
    const currentItem = dataSource[index];
    const nextItem = dataSource[index + 1];

    const isTransitionOn =
      currentItem.state === 'false' &&
      nextItem.state === 'true' &&
      currentItem.device === nextItem.device;
    const isTransitionOff =
      currentItem.state === 'true' &&
      nextItem.state === 'false' &&
      currentItem.device === nextItem.device;

    const deviceName = pumpLabel[currentItem.device] || currentItem.device;

    const startTime = moment(currentItem.time).valueOf();
    const endTime = moment(nextItem.time).valueOf();

    const transitionData = {
      x: deviceName,
      y: [endTime, startTime],
    };

    if (isTransitionOn) {
      dataOn.push(transitionData);
    } else if (isTransitionOff) {
      dataOff.push(transitionData);
    }

    currentDevice = deviceName;
  }

  dataOn?.map((value) => {
    seconds2 =
      moment(value.y[1] * 1000).hours() * 60 * 60 +
      moment(value.y[1] * 1000).minutes() * 60 +
      moment(value.y[1] * 1000).seconds();
    seconds1 =
      moment(value.y[0] * 1000).hours() * 60 * 60 +
      moment(value.y[0] * 1000).minutes() * 60 +
      moment(value.y[0] * 1000).seconds();
    if (seconds2 < seconds1) seconds2 += 24 * 60 * 60;
    result += seconds2 - seconds1;
  });

  hours = (result / (60 * 60)) % 24;
  minutes = (result / 60) % 60;
  seconds = result % 60;
  sum = parseInt(hours) + ':' + parseInt(minutes) + ':' + seconds;

  const series = [
    {
      name: 'On',
      data: dataOn,
    },
    {
      name: 'Off',
      data: dataOff,
    },
  ];

  const options = {
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '20%',
        rangeBarGroupRows: true,
      },
    },
    colors: ['#2ca961', '#999999'],
    fill: {
      type: ['gradient', 'pattern'],
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.25,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [50, 0, 100, 100],
      },
      pattern: {
        style: 'slantedLines',
        width: 6,
        height: 6,
        strokeWidth: 2,
      },
    },
    xaxis: {
      type: 'datetime',
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
    },
    tooltip: {
      x: {
        format: 'HH:mm:ss',
      },
    },
  };

  function onSelectDate(date, dateString) {
    setDatepicker(dateString);
  }

  return (
    <>
      <Row>
        <Col md={12}>
          <div className="info-time">
            <DatePicker
              onChange={onSelectDate}
              defaultValue={moment(date, dateFormat)}
            />
            <p>
              {t('active-time')}
              <span>{sum}</span>
            </p>
          </div>
        </Col>
      </Row>
      <Row id="chart" style={{ marginTop: '20px' }}>
        <Col md={12}>
          <ReactApexChart
            options={options}
            series={series}
            type="rangeBar"
            height={400}
          />
        </Col>
      </Row>
    </>
  );
}

export default React.memo(Timeline);
